import i18n from "@/i18n";
export const TRANSACTION_TYPES = {
  TYPE_SHOP: 1,
  TYPE_FUEL: 2,
  TYPE_SHOP_AND_FUEL: 3,
  TYPE_POINT_BONUS: 4,
  TYPE_STAMPS_CORRECTION: 11,
  TYPE_CASHOUT_REQUEST: 12,
  TYPE_FUELPOINTS_CORRECTION: 13, //for adding/deleting fuelpoints
  TYPE_FUELPOINTS_SALE: 14, //for using fuelpoints to buy services
  TYPE_REDEEM_VOUCHER: 20,
  TYPE_REFUND_VOUCHER: 21
};

export const TRANSLATABLE_TRANSACTION_TYPES = [
  {
    key: TRANSACTION_TYPES.TYPE_SHOP,
    translation: i18n.t("transaction_type.shop")
  },
  {
    key: TRANSACTION_TYPES.TYPE_FUEL,
    translation: i18n.t("transaction_type.fuel")
  },
  {
    key: TRANSACTION_TYPES.TYPE_SHOP_AND_FUEL,
    translation: i18n.t("transaction_type.shop_and_fuel")
  },
  {
    key: TRANSACTION_TYPES.TYPE_POINT_BONUS,
    translation: i18n.t("transaction_type.point_bonus")
  },
  {
    key: TRANSACTION_TYPES.TYPE_STAMPS_CORRECTION,
    translation: i18n.t("transaction_type.stamps_correction")
  },
  {
    key: TRANSACTION_TYPES.TYPE_CASHOUT_REQUEST,
    translation: i18n.t("transaction_type.cashout_request")
  },
  {
    key: TRANSACTION_TYPES.TYPE_FUELPOINTS_CORRECTION,
    translation: i18n.t("transaction_type.fuelpoint_correction")
  },
  {
    key: TRANSACTION_TYPES.TYPE_FUELPOINTS_SALE,
    translation: i18n.t("transaction_type.shop")
  },
  {
    key: TRANSACTION_TYPES.TYPE_REDEEM_VOUCHER,
    translation: i18n.t("transaction_type.redeem_voucher")
  },
  {
    key: TRANSACTION_TYPES.TYPE_REFUND_VOUCHER,
    translation: i18n.t("transaction_type.refund_voucher")
  }
];
